(function () {
  let agreementLinkClicked = false;

  const AGREEMENT_SELECTOR =
    '.primy-form a[href*="influencer-brand-ambassador"]';

  // Sözleşme linkine tıklanmasını izle
  document.addEventListener(
    'click',
    function (event) {
      const agreementLink = event.target.closest(AGREEMENT_SELECTOR);

      if (agreementLink) {
        agreementLinkClicked = true;
      }
    },
    true
  );

  // Gönder butonunu yakala
  document.addEventListener(
    'click',
    function (event) {
      const submitButton = event.target.closest(
        '.primy-form button[type="submit"]'
      );

      if (!submitButton) return;

      if (!agreementLinkClicked) {
        event.preventDefault();
        event.stopPropagation();
        event.stopImmediatePropagation();

        alert(
          'Başvuruyu göndermeden önce lütfen INFLUENCER / BRAND AMBASSADOR İşbirliği Sözleşmesi bağlantısına tıklayarak sözleşmeyi inceleyin.'
        );

        const agreementLink = document.querySelector(AGREEMENT_SELECTOR);

        if (agreementLink) {
          agreementLink.scrollIntoView({
            behavior: 'smooth',
            block: 'center'
          });
        }

        return false;
      }
    },
    true
  );

  // Primy normal submit eventini kullanırsa ikinci güvenlik kontrolü
  document.addEventListener(
    'submit',
    function (event) {
      const form = event.target;

      if (!form.matches('.primy-form .pmyf-form')) return;

      if (!agreementLinkClicked) {
        event.preventDefault();
        event.stopPropagation();
        event.stopImmediatePropagation();

        alert(
          'Başvuruyu göndermeden önce sözleşme bağlantısına tıklamanız gerekmektedir.'
        );

        return false;
      }
    },
    true
  );
})();